import { render } from "./app-icon-select.vue?vue&type=template&id=3351643d"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-select.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3351643d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3351643d', __exports__)) {
    console.log('reload')
    api.reload('3351643d', __exports__)
  }
  
  module.hot.accept("./app-icon-select.vue?vue&type=template&id=3351643d", () => {
    console.log('re-render')
    api.rerender('3351643d', render)
  })

}


export default __exports__